module.exports = __webpack_public_path__ + "media/images/meta/digi-wedding-en-2c346d424ddda3caa5b3088b9790c002.png";